const FOOTER_DATA = [
  {
    title: "",
    items: [
      {
        title:
          "Boldspace is a coworking office that aids in collaboration and development in achieving business goals by providing comfortable workstations.",
      },
    ],
  },
  {
    title: "Company",
    items: [
      {
        title: "About",
        href: "/about",
      },
      {
        title: "Contact",
        href: "/contact",
      },
    ],
  },
  {
    title: "Legal",
    items: [
      {
        title: "Term of use",
        // href: "#",
      },
    ],
  },
];

export default FOOTER_DATA;
